import { useEffect, useRef, useState } from 'react';
/**
 * @returns {[import('react').MutableRefObject<null>, boolean, (open: boolean) => void]}
 */
export default function useClickOut() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const handleClick = (e) => {
    if (ref && ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  };

  const handleEscape = (e) => {
    if (e.key === 'Escape') {
      setOpen(false);
    }
  };

  useEffect(() => {
    const node = ref.current;

    if (node) {
      document.addEventListener('click', handleClick);
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.removeEventListener('click', handleClick);
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [ref.current]);

  return [ref, open, setOpen];
}
